import { getSystemProperties } from './api/system';
import { SYSTEM_PROPERTIES_SET } from '../constants/systemPropertiesTypes';

export const systemProperties = (type, key) => async (dispatch) => {
  if (!type) {
    return;
  }

  return getSystemProperties(type)
    .then((response) => {
      const { data } = response;

      dispatch({
        type: SYSTEM_PROPERTIES_SET,
        payload: {
          type: key,
          data,
        },
      });

      return data;
    })
    .catch((err) => {
      console.error('Error fetching system properties', err);
    });
};
